// import Link from 'next/link';
import React, {useEffect, useState} from 'react'
import ImageList from "./image-list";
import ImageDetail from "./image-detail";
import {Link} from "react-router-dom";
import {searchTags} from "../common/services/tag-data-service";
import _ from "lodash";
import {searchThemes} from "../theme/services/theme-data-service";

const ImageDashboard = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [allTags, setAllTags] = useState([]);
    const [allThemes, setAllThemes] = useState([]);
    const [allFilterTags, setAllTFilterTags] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageRemoved, setSelectedImageRemoved] = useState(false);

    useEffect(() => {
        if (initialStep) {
            fetchTagsList();
            getThemesList();
        }
    }, [initialStep]);

    const getThemesList = async () => {
        const themesListResult = await searchThemes('')
        setAllThemes(themesListResult);
    }

    const fetchTagsList = async () => {
        const tagsListResult = await searchTags('');
        setAllTags(tagsListResult);
        setAllTFilterTags(_.cloneDeep(tagsListResult));
    }

    return (
        <>

            <div className="page-container dashboard-container">
                <div className="items-center justify-start w-1/3 p-8">
                    <div className="flex justify-between mb-6">
                        <div className="text-xl">
                            Images
                        </div>

                        <div className="flex justify-end">
                            <div className="mr-2">
                                <a href="/images/edit-multiple-images" className="button-medium">
                                    <span>Edit Multiple Images</span>
                                </a>
                            </div>

                            <div className="">
                                <a href="/images/upload-images" className="button-medium">
                                    <span>Upload Images</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <ImageList
                        allTags={allFilterTags}
                        setSelectedImageRemoved={setSelectedImageRemoved}
                        selectedImageRemoved={selectedImageRemoved}
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}/>
                </div>

                <div className="items-center justify-start w-2/3 pb-16 mr-8 my-8">
                    {selectedImage &&
                        <ImageDetail
                            allTags={allTags}
                            allThemes={allThemes}
                            setSelectedImageRemoved={setSelectedImageRemoved}
                            selectedImage={selectedImage}
                            setSelectedImage={setSelectedImage}/>
                    }
                </div>
            </div>

        </>
    )
}

export default ImageDashboard
